import { Box, Button } from '@mui/material';
import { useContext, useState } from 'react';
import Joyride from 'react-joyride';
import { ToolContext } from '../../../../core/context/ToolContext';
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';

export const CustomComponent = ({ step, index, totalSteps, primaryProps, closeProps, tooltipProps }) => {
	return (
		<Box {...tooltipProps} width="340px" p={2} bgcolor="#fff" borderRadius="8px">
			<Box fontSize="14px" fontWeight="600">{step.title}</Box>
			<Box fontSize="12px" py="4px">{step.content}</Box>

			<Box width="100%" display="flex" justifyContent="flex-end"  gap="4px">
				{[0, 1].includes(index) &&
					<Button {...closeProps} variant="text" sx={{ fontSize: '12px', p: '4px 16px' }}>
						Skip
					</Button>
				}
				<Button {...primaryProps} variant="contained" disableElevation sx={{fontSize: '12px', p: '4px 16px'}}>
					{index === 2 ? "Got it!" : "Next"}
				</Button>
			</Box>
		</Box>
	);
};

const steps = [
	{
		target: '.twelfth-step',
		title: 'Publication button',
		content: 'This button is for filter publication type',
		placement: 'right',
		disableBeacon: true,
		disableScrollParentFix: true,
		disableScrolling: true,
	},
	{
		target: '.thirteenth-step',
		title: 'Publication list item',
		content: 'Click this item to read publication content',
		placement: 'right',
		disableBeacon: true,
		disableScrollParentFix: true,
		disableScrolling: true,
	},
	{
		target: '.fourteenth-step',
		title: 'Save',
		content: 'Click this button to sa publication item',
		placement: 'right',
		disableBeacon: true,
		disableScrollParentFix: true,
		disableScrolling: true,
	},
];


export const Publication = () => {
	const { tool_state, personalization_state } = useContext(ToolContext);
	const { __SESSION } = tool_state;
	const { walkthrough } = personalization_state
	
	const [stepIndex, setStepIndex] = useState(0);

	const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8);
	const tool_id =  process.env.REACT_APP_TID_PSL;

	const handleJoyrideCallback = async (data) => {
		const { status, action, index, type } = data;
		
		let body = {
			user_id: user_id,
			tool_id: tool_id,
			feature_name: 'publication',
			personalization:[{sf_name: 'publication' , status: 1}]
		}

		if (type === 'step:after' && action === 'next') {
			setStepIndex(index + 1);
		}

		if (status === "finished") {
			const res = await rqx.post(`<<global>>/${env()}/personalization/create`, body)
			if (res.msg === 'success') {
				walkthrough.set(prev => ({...prev, publication: false}))
			}
		}
		
		if (['close', 'stop'].includes(action)) {
			walkthrough.set(prev => ({...prev, publication: false}))
			setStepIndex(0);
			await rqx.post(`<<global>>/${env()}/personalization/create`, body)
		}
	};	

	return (
			<Joyride
				continuous
				disableOverlayClose={true}
				run={walkthrough.data.publication}
				steps={steps}
				stepIndex={stepIndex}
				showSkipButton={true}
				callback={handleJoyrideCallback}
				tooltipComponent={CustomComponent}
			/>

	);
};
